import { useState, useEffect } from 'react';
import styles from './styles';

interface ToggleProps {
  label: string;
  id: string;
  onClick: (value: boolean) => void;
  isToggled?: boolean;
}

function Toggle({
  label,
  id,
  onClick,
  isToggled: initialIsToggled = false,
}: ToggleProps): JSX.Element {
  const [isToggled, setIsToggled] = useState(initialIsToggled);
  useEffect(() => {
    setIsToggled(initialIsToggled);
  }, [initialIsToggled]);

  function handleClick(): void {
    const newValue = !isToggled;
    setIsToggled(newValue);
    onClick(newValue);
  }

  return (
    <span className="toggle-container">
      <label className="toggle-label" htmlFor={id}>
        {label}
      </label>
      <span className="toggle-switch" onClick={handleClick}>
        <span
          className="toggle-switch-base"
          style={{
            transform: isToggled ? 'translateX(20px)' : 'none',
          }}
        >
          <input type="checkbox" role="switch" className="toggle-switch-input" id={id} checked />
          <span className="toggle-switch-thumb" />
        </span>
        <span
          className="toggle-switch-track"
          style={{
            backgroundColor: isToggled ? '#F20902' : '#EBEBEB',
          }}
        />
      </span>

      <style jsx>{styles}</style>
    </span>
  );
}
export default Toggle;
